import React, { useEffect, useRef, useState } from "react";
import ss from "./CreateGame.module.css";
import Avatar from "../Avatar";
import classNames from "classnames";
import Cipher from "../Cipher";
import { apiRequest, showLoading, showAlert, showToast } from "../../utils";

const getCurrentTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1);
  const day = String(date.getDate());
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}/${month}/${day}-${hours}:${minutes}`;
};

export default function CreateGame(props) {
  const { clone, new_card, pass = false, session_uuid } = props;
  const [sessionName, setSessionName] = useState("");
  const [num, setNum] = useState(60);
  const [map, setMap] = useState();
  const [up1, setUp1] = useState(10);
  const [up2, setUp2] = useState(10);
  const [mapList, setMapList] = useState([]);

  // 管理员密码
  const [password, setPassword] = useState("");

  const [team, setTeam] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  // 判断是否需要输入密码
  useEffect(() => {
    if (pass) {
      passwordPopup();
    } else {
      configPopup();
    }

    const loading = showLoading("加载中");
    apiRequest("/get_map_list", "GET", {
      store_uuid: localStorage.getItem("store_uuid"),
    })
      .then((res) => {
        if (res.code === 0) {
          setMapList(res.maps);
          if (res.maps.length > 0) setMap(res.maps[0].id);
          if (!session_uuid) return; // 存在则表示标记场次信息
          const loading = showLoading("加载中");
          apiRequest("/get_session_info", "GET", { session_uuid })
            .then((res) => {
              if (res.code === 0) {
                setSessionName(res.game_session.name);
                setNum(res.game_session.duration);
                setMap(res.game_session.map_id);
                setUp1(res.game_session.upgrade_condition.split("-")[0]);
                setUp2(res.game_session.upgrade_condition.split("-")[1]);
                const teamColors = res.game_session.team_colors
                  .split(",")
                  .map(Number);
                console.log(teamColors);
                setTeam((t) =>
                  t.map((_, index) => {
                    return teamColors.includes(index + 1);
                  })
                );
              } else {
                showAlert(res.msg);
              }
            })
            .catch((err) => console.log(err))
            .finally(() => loading.hide());
        } else {
          showAlert(res.msg);
        }
      })
      .catch((err) => showAlert("请求失败，请稍后重试", err.message))
      .finally(() => loading.hide());
  }, [pass, session_uuid]);

  //密码框出现
  const passwordPopup = () => {
    const adm_box = document.getElementById("adm_box");
    adm_box.classList.add(ss.on);
  };
  // 配置框出现
  const configPopup = () => {
    const avatar_box = document.getElementById("avatar_box");
    const select_box = document.getElementById("select_box");
    avatar_box.classList.add(ss.on);
    select_box.classList.add(ss.on);
  };

  const [active, setActive] = useState(false);

  const fadeoutPopup = () => {
    const signOut = document.getElementById("signOut");
    const block = document.getElementById("block");
    block.classList.add(ss.Blockfadeout);
    signOut.classList.add(ss.fadeoutEff);
    setTimeout(() => {
      clone();
    }, 0.5 * 1000);
  };

  const exit = () => {
    fadeoutPopup();
  };

  // 函数来获取所有true值的下标
  const getTrueIndices = () => {
    return team.reduce((indices, item, index) => {
      if (item) {
        indices.push(index + 1);
      }
      return indices;
    }, []);
  };

  //选择队伍
  const selectTeam = (num) => {
    let newTeam = [...team];
    newTeam[Number(num) - 1] = !newTeam[Number(num) - 1];
    setTeam(newTeam);
  };

  useEffect(() => {
    if (
      sessionName &&
      team.filter((value) => value === true).length !== 0 &&
      num &&
      map &&
      up1 &&
      up2
    ) {
      setActive(true);
    } else {
      setActive(false);
    }
    // eslint-disable-next-line
  }, [sessionName, team, num, map, up1, up2]);

  const clock = () => {
    if (pass) {
      const adm_box = document.getElementById("adm_box");
      if (adm_box.style.display === "none") {
        const loading = showLoading("加载中");
        apiRequest("/update_game_session", "POST", {
          session_uuid,
          name: sessionName,
          duration: num,
          map_id: map,
          upgrade_condition: `${up1}-${up2}`,
          team_colors: getTrueIndices().join(","),
        })
          .then((res) => {
            if (res.code === 0) {
              showToast("调整成功");
              new_card();
              exit();
            } else showAlert(res.msg);
          })
          .catch((err) => showAlert("请求失败，请稍后重试", err.message))
          .finally(() => loading.hide());
        return;
      }
      if (password === "2123") {
        adm_box.classList.remove(ss.on);
        setTimeout(() => {
          configPopup();
          adm_box.style.display = "none";
        }, 0.5 * 1000);
      } else {
        alert("密码错误");
      }
    } else {
      const loading = showLoading("加载中");
      apiRequest("/create_game_session", "POST", {
        store_uuid: localStorage.getItem("store_uuid"),
        name: sessionName,
        duration: num,
        map_id: map,
        upgrade_condition: `${up1}-${up2}`,
        team_colors: getTrueIndices().join(","),
      })
        .then((res) => {
          if (res.code === 0) {
            showToast("创建成功");
            new_card();
            exit();
          } else showAlert(res.msg);
        })
        .catch((err) => showAlert("请求失败，请稍后重试", err.message))
        .finally(() => loading.hide());
    }
  };

  // 密码输入完成
  const onCipherComplete = (v) => {
    console.log("触发了");
    setPassword(v);
    console.log(password);
    if (v && v.length === 4) {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  useEffect(() => {
    setSessionName(getCurrentTime());
  }, []);

  return (
    <div className={ss.bg}>
      <div className={ss.signOut}>
        <div className={ss.black} id="block"></div>
        <div className={ss.tooltip} id="signOut">
          <div
            className={ss.X}
            onClick={() => {
              exit();
            }}
          ></div>
          <div className={ss.create_txt}>
            <input
              name="sessionName"
              contentEditable={!pass}
              className={ss.sessionName}
              type="text"
              maxLength={20}
              placeholder="请设置场次名称"
              value={sessionName}
              onChange={(e) => {
                setSessionName(e.target.value);
              }}
            />
          </div>

          <div className={ss.select_box} id="select_box">
            <div className={ss.select}>
              <div className={ss.select_txt}>游戏时长</div>
              <input
                className={ss.select_inp}
                value={num}
                type="number"
                onChange={(e) => {
                  setNum(e.target.value);
                }}
              />
            </div>
            <div className={ss.select}>
              <div className={ss.select_txt}>地图</div>
              <select
                className={ss.select_inp}
                onChange={(e) => {
                  setMap(e.target.value);
                }}
                value={map}
              >
                {mapList.map((item, index) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className={ss.select}>
              <div className={ss.select_txt}>升级1</div>
              <input
                className={ss.select_inp}
                value={up1}
                type="number"
                onChange={(e) => {
                  setUp1(e.target.value);
                }}
              />
            </div>
            <div className={ss.select}>
              <div className={ss.select_txt}>升级2</div>
              <input
                className={ss.select_inp}
                value={up2}
                type="number"
                onChange={(e) => {
                  setUp2(e.target.value);
                }}
              />
            </div>
          </div>
          <div className={ss.avatar_box} id="avatar_box">
            <div className={ss.avatar}>
              {Array.from({ length: 10 }, (_, index) => (
                <Avatar
                  key={index} // 确保每个组件都有一个唯一的key
                  num={index + 1} // 索引从0开始，但编号从1开始
                  active={team[index]}
                  width={1.67}
                  selectTeam={(v) => {
                    const select_box = document.getElementById("select_box");
                    if (!select_box.classList.contains(ss.on)) return;
                    selectTeam(`${v}`);
                  }}
                />
              ))}
            </div>
          </div>
          <div className={classNames(ss.adm, pass && ss.show)} id="adm_box">
            <div className={ss.adm_txt}>请输入管理员密码</div>
            <div className={ss.adm_box}>
              <Cipher num={4} onCipherComplete={(v) => onCipherComplete(v)} />
            </div>
          </div>
          <div className={ss.btn_box}>
            <div
              className={ss.btn_no}
              onClick={() => {
                exit();
              }}
            ></div>
            <div
              className={classNames(ss.btn_yes, active && ss.btn_yes_active)}
              onClick={() => {
                clock();
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}
